import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

const InvoicingModalCard = ({
  isInvoicingModalOpen,
  setIsInvoicingModalOpen,
  person,
}) => {
  const regularAddress = [person.address, person.city].join(", ");
  const invoicingAddress = person.billingAddress || regularAddress;

  return (
    <Transition.Root show={isInvoicingModalOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
                <h5 className="font-medium leading-tight text-xl my-5 ofcDarkBlue text-center">
                  Dati di Fatturazione
                </h5>

                <div className="grid grid-cols-1 gap-2">
                  {person.companyName && (
                    <>
                      <div className="col-span-2 font-bold">
                        Ragione Sociale
                      </div>
                      <div>{person.companyBillingName}</div>
                    </>
                  )}
                  {invoicingAddress && (
                    <>
                      <div className="col-span-2 font-bold">Indirizzo</div>
                      <div>{invoicingAddress}</div>
                    </>
                  )}
                  {person.vat && (
                    <>
                      <div className="col-span-2 font-bold">Partita IVA</div>
                      <div>{person.vat}</div>
                    </>
                  )}
                  {person.pec && (
                    <>
                      <div className="col-span-2 font-bold">PEC</div>
                      <div>{person.pec}</div>
                    </>
                  )}
                  {person.electronicInvoicingId && (
                    <>
                      <div className="col-span-2 font-bold">
                        Codice Destinatario
                      </div>
                      <div>{person.electronicInvoicingId}</div>
                    </>
                  )}
                </div>
                <div className="mt-5 ">
                  <button
                    type="button"
                    className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-ofcBlue text-xl  text-white hover:bg-ofcGreen focus:outline-none"
                    onClick={() => setIsInvoicingModalOpen(false)}
                  >
                    Torna alla card
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default InvoicingModalCard;
